import React, { lazy, Suspense } from "react";
import { Switch, Redirect } from "react-router-dom";
import {
  APP_LOYALTY_PREFIX_PATH,
  AUTH_LOYALTY_PREFIX_PATH,
} from "configs/AppConfig";
import Loading from "components/shared-components/Loading";
import PrivatePatientRoute from "shared/PrivatePatientRoute";
import CheckoutPage from "./Cart/checkoutPage";

export const AppLoyaltyViews = () => {
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        <PrivatePatientRoute
          path={`${APP_LOYALTY_PREFIX_PATH}/home`}
          component={lazy(
            () => import("../../loyalty-app/app-loyalty-views/HomePage/index"),
          )}
          exact
        />
        <PrivatePatientRoute
          path={`${APP_LOYALTY_PREFIX_PATH}/rewards`}
          component={lazy(
            () =>
              import("../../loyalty-app/app-loyalty-views/RewardsPage/index"),
          )}
          exact
        />
        <PrivatePatientRoute
          path={`${APP_LOYALTY_PREFIX_PATH}/profile`}
          component={lazy(
            () =>
              import("../../loyalty-app/app-loyalty-views/ProfilePage/index"),
          )}
          exact
        />
        <PrivatePatientRoute
          path={`${APP_LOYALTY_PREFIX_PATH}/profile-rewards`}
          component={lazy(
            () =>
              import("../../loyalty-app/app-loyalty-views/ProfilePage/VouchersPage"),
          )}
          exact
        />
        <PrivatePatientRoute
          path={`${APP_LOYALTY_PREFIX_PATH}/profile-memberships`}
          component={lazy(
            () =>
              import("../../loyalty-app/app-loyalty-views/ProfilePage/membershipsOverview"),
          )}
          exact
        />
        <PrivatePatientRoute
          path={`${APP_LOYALTY_PREFIX_PATH}/level`}
          component={lazy(
            () =>
              import("../../loyalty-app/app-loyalty-views/ProfilePage/singleLevelPage"),
          )}
          exact
        />
        <PrivatePatientRoute
          path={`${APP_LOYALTY_PREFIX_PATH}/activities`}
          component={lazy(
            () =>
              import("../../loyalty-app/app-loyalty-views/ProfilePage/ActivityPage"),
          )}
          exact
        />
        <PrivatePatientRoute
          path={`${APP_LOYALTY_PREFIX_PATH}/consent-forms/view`}
          component={lazy(
            () => import("./ProfilePage/ConsentFormsPage/ConsentFormViewPage"),
          )}
          exact
        />
        <PrivatePatientRoute
          path={`${APP_LOYALTY_PREFIX_PATH}/consent-forms`}
          component={lazy(() => import("./ProfilePage/ConsentFormsPage"))}
          exact
        />
        <PrivatePatientRoute
          path={`${APP_LOYALTY_PREFIX_PATH}/appointments`}
          component={lazy(
            () =>
              import("../../loyalty-app/app-loyalty-views/AppointmentsPage/index"),
          )}
          exact
        />
        <PrivatePatientRoute
          path={`${APP_LOYALTY_PREFIX_PATH}/booking`}
          component={lazy(
            () =>
              import("../../loyalty-app/app-loyalty-views/BookingPage/index"),
          )}
          exact
        />
        <PrivatePatientRoute
          path={`${APP_LOYALTY_PREFIX_PATH}/doctors`}
          component={lazy(
            () =>
              import("../../loyalty-app/app-loyalty-views/DoctorsPage/index"),
          )}
          exact
        />
        <PrivatePatientRoute
          path={`${APP_LOYALTY_PREFIX_PATH}/services`}
          component={lazy(() => import("./ServicesPage/index"))}
          exact
        />
        <PrivatePatientRoute
          path={`${APP_LOYALTY_PREFIX_PATH}/info`}
          component={lazy(
            () => import("../../loyalty-app/app-loyalty-views/InfoPage/index"),
          )}
          exact
        />
        <PrivatePatientRoute
          path={`${APP_LOYALTY_PREFIX_PATH}/memberships`}
          component={lazy(
            () =>
              import("../../loyalty-app/app-loyalty-views/MembershipsPage/index"),
          )}
          exact
        />
        <PrivatePatientRoute
          path={`${APP_LOYALTY_PREFIX_PATH}/membership-details/:id`}
          component={lazy(
            () =>
              import("../../loyalty-app/app-loyalty-views/MembershipsPage/offerMembershipPurchase"),
          )}
          exact
        />
        <PrivatePatientRoute
          path={`${APP_LOYALTY_PREFIX_PATH}/checkout/:variation_id`}
          component={CheckoutPage}
          exact
        />
        <PrivatePatientRoute
          path={`${APP_LOYALTY_PREFIX_PATH}/edit-profile`}
          component={lazy(() => import(`../../app-views/components/Profile`))}
          exact
        />
        <PrivatePatientRoute
          path={`${APP_LOYALTY_PREFIX_PATH}/edit-password`}
          component={lazy(
            () => import(`../../app-views/components/ChangePassword`),
          )}
          exact
        />
        <Redirect
          from={`${APP_LOYALTY_PREFIX_PATH}`}
          to={`${AUTH_LOYALTY_PREFIX_PATH}/login`}
        />
      </Switch>
    </Suspense>
  );
};

export default AppLoyaltyViews;
